import React from "react";
import { EligibilityReportsContainer } from "../../../containers";

const EligibilityReports = (props) => {
  return <EligibilityReportsContainer {...props} />;
};

export default EligibilityReports;
